import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import Loading from '../../v2-components/Loading';
import Pharmacies from '../../v2-components/Pharmacies';
import ProductReport from './components/ProductReport';
import { Language } from './constants/language.constant';
import { Service } from './service';

import './style.scss';

export default function AdminReportPage() {
	const [data, setData] = useState();
	const [options, setOptions] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [pharmacy, setPharmacy] = useState();

	useEffect(() => {
		const handleGetData = () => {
			new Service().getReports(pharmacy).then((response) => {
				setData(response);
				setIsLoading(false);
			});
		};
		handleGetData();
		new Service().getPharmacies().then((response) => {
			const mapOptions = response.data.map((iterator) => {
				return {
					label: iterator.name_editable,
					value: iterator.name,
				};
			});

			setOptions([...mapOptions]);
		});
	}, [pharmacy]);

	if (isLoading) {
		return <Loading />;
	}

	const handleSelectChange = (value) => {
		setPharmacy(value);
	};

	const getPharmacyLabel = (pharmacySelected, selectOptions) => {
		if(pharmacySelected){
			const optionSelected = selectOptions.filter(item => item.value === pharmacySelected)
			return optionSelected[0].label
		}
	}

	return (
		<div className="ph-admin-report-page-container">
			<Row justify="center">
				<Col>
					<h2 style={{ color: 'grey' }}>{Language[Enviroment.LANGUAGE]?.title} {pharmacy && getPharmacyLabel(pharmacy, options)}</h2>
				</Col>
			</Row>
			<Row justify="center">
				<Pharmacies style={{ width: '50%' }} options={options} onChange={handleSelectChange} />
			</Row>
			<Row>
				<Col span={24}>
					<ProductReport data={data} />
				</Col>
			</Row>
		</div>
	);
}
